module.exports = __webpack_public_path__ + "static/venice20898-70c9d16b2464422bca59eb953b6c8252.webp";